import { PaymentTermKind } from './PaymentTermKind';

export enum PaymentTermStatus {
	SETTLED = 'S',
	UNSETTLED = 'U',
	PARTIALLY_SETTLED = 'P',
	OVERSETTLED = 'O',
	COMMISSION_TAKEN = 'C',
}

export const paymentTermStatusByKindMappings: Record<PaymentTermKind, Partial<Record<PaymentTermStatus, string>>> = {
	[PaymentTermKind.PAYMENT]: {
		[PaymentTermStatus.SETTLED]: 'zapłacono',
		[PaymentTermStatus.UNSETTLED]: 'nie zapłacono',
		[PaymentTermStatus.PARTIALLY_SETTLED]: 'częściowo zapłacono',
		[PaymentTermStatus.OVERSETTLED]: 'zapłacono za dużo',
	},
	[PaymentTermKind.REFUND]: {
		[PaymentTermStatus.SETTLED]: 'zwrócono',
		[PaymentTermStatus.UNSETTLED]: 'nie zwrócono',
	},
	[PaymentTermKind.COMMISSION]: {
		[PaymentTermStatus.SETTLED]: 'prowizja rozliczona',
		[PaymentTermStatus.UNSETTLED]: 'prowizja nie rozliczona',
		[PaymentTermStatus.COMMISSION_TAKEN]: 'prowizja kompensata',
	},
};

export enum PaymentSource {
	MANUAL = 'MA',
	AUTOMATIC = 'AU',
}

export enum PaymentStatus {
	IN_PROGRESS = 'PE',
	COMPLETED = 'CO',
	CANCELED = 'CA',
}

export const paymentStatusLabelMappings: Record<PaymentStatus, string> = {
	[PaymentStatus.IN_PROGRESS]: 'W trakcie',
	[PaymentStatus.COMPLETED]: 'Zakończona',
	[PaymentStatus.CANCELED]: 'Anulowana',
};

export enum PaymentStatusReservation {
	UNPAID = 'unpaid',
	PARTIALLY_PAID = 'partially_paid',
	FULLY_PAID = 'fully_paid',
	OVERPAID = 'overpaid',
}

export const paymentStatusMappings: {
	[key in PaymentStatusReservation]: string;
} = {
	[PaymentStatusReservation.UNPAID]: 'nieopłacona',
	[PaymentStatusReservation.PARTIALLY_PAID]: 'częściowo opłacona',
	[PaymentStatusReservation.FULLY_PAID]: 'opłacona',
	[PaymentStatusReservation.OVERPAID]: 'nadpłacona',
};
